import React from "react"
import Modal from "../settings-modal"
import Input from "../dashboard-input"
import SettingsButton from "../settings-button"

const AddOrderModal = ({
  onSubmit,
  onChange,
  newOrder,
  formSubmitting,
  ...props
}) => (
  <Modal className={"liftwalletModal"} title={"Create a new Order"} {...props}>
    <div className={"sub-title"}>
      <p className={"m-0"}>Please fill in the form to create your order</p>
    </div>
    <form onSubmit={onSubmit}>
      <Input
        type={"text"}
        className={"w-100"}
        placeholder={"Discord ID"}
        label={"Discord ID"}
        disabled
        value={props.user.id}
        name={"discordId"}
        readOnly
        required
      />
      <Input
        type={"text"}
        className={"w-100"}
        select
        placeholder={"Select a service"}
        label={"Service"}
        name={"service"}
        onChange={onChange}
        value={newOrder.service}
        required
        fullWidth
      >
        <option value="">Select a service</option>
        <option value="Discord bot">Discord bot</option>
        <option value="Hosting">Bot Hosting</option>
        <option value="Scripting">Scripting</option>
        <option value="Building">Other</option>
      </Input>
      <Input
        className={"w-100"}
        placeholder={
          "Please fully describe the functions and feautures you want."
        }
        textarea
        label={"Description"}
        name={"description"}
        onChange={onChange}
        value={newOrder.description}
        required
      />
      <Input
        type={"text"}
        className={"w-100"}
        placeholder={"Budget"}
        label={"Budget"}
        name={"budget"}
        value={newOrder.budget}
        onChange={onChange}
        required
      />
      <SettingsButton disabled={formSubmitting}>
        {formSubmitting ? (
          <i className={"fas fa-fw fa-spinner fa-spin"} />
        ) : (
          "Create Order"
        )}
      </SettingsButton>
    </form>
  </Modal>
)

export default AddOrderModal



// WEBPACK FOOTER //
// ./src/components/add-order-modal/AddOrderModal.js